import { createRoute } from '@tanstack/react-router'
import { guestLayoutRoute } from 'src/layouts/routes'

export const orderYarcheGuestRoute = createRoute({
  getParentRoute: () => guestLayoutRoute,
  path: '/order-yarche-guest'
})
